import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpCemex } from '../services/api.service';
import { createHttpParams, formatEntityIdParameters } from '../shared/helpers';

// INTERFACES
import { IPointOfDeliverySalesAreasRequest } from '../models/point-of-delivery-sales-areas/point-of-delivery-sales-areas-request';
import { IPointOfDeliverySalesAreasResponse } from '../models/point-of-delivery-sales-areas/point-of-delivery-sales-areas-response';

@Injectable()
export class PointOfDeliverySalesAreasService {
  constructor(private http: HttpCemex) {}

  getPointOfDeliverySalesAreas(request: IPointOfDeliverySalesAreasRequest): Observable<IPointOfDeliverySalesAreasResponse> {
    const httpParams = request ? createHttpParams(request) : new HttpParams();
    return this.http.get<IPointOfDeliverySalesAreasResponse>(`/v5/sm/pointofdeliverysalesareas`, {
      params: httpParams,
    });
  }

  getAddresses(payload: IPointOfDeliverySalesAreasRequest): Observable<IPointOfDeliverySalesAreasResponse> {
    const httpParams = payload ? createHttpParams(formatEntityIdParameters(payload)) : new HttpParams();
    return this.http.get<IPointOfDeliverySalesAreasResponse>(`/v5/sm/pointofdeliverysalesareas`, {
      params: httpParams,
    });
  }
}
